"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomSqlTextLink = exports.CustomSqlDialog = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var clipboard = __importStar(require("clipboard-polyfill"));
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var CustomSqlStyles_1 = require("./CustomSqlStyles");
function CustomSqlDialog(props) {
    var title = props.selectedDropdownName
        ? "".concat(Localize_1.Messages.CustomSqlDialogTitle(), ": ").concat(props.selectedDropdownName)
        : Localize_1.Messages.CustomSqlDialogTitle();
    return (react_1.default.createElement(widgets_1.DialogWidget, { testId: 'Custom-Sql-Dialog', title: title, type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Draggable, showCloseButton: true, isModal: true, onCloseRequest: props.onClose, handleGlassClick: props.onClose, dialogWidth: CustomSqlStyles_1.customSqlDialogWidth, dialogHeight: CustomSqlStyles_1.customSqlDialogHeight, dialogBodyStyle: CustomSqlStyles_1.customSqlDialogStyle, footerContent: props.customSQLTables.length === 1 ? react_1.default.createElement(RenderDialogFooter, { customSQLTables: props.customSQLTables }) : null }, props.customSQLTables.map(function (table, index) {
        return react_1.default.createElement("ul", { key: index, className: CustomSqlStyles_1.customSqlQueryListClass },
            react_1.default.createElement("li", null,
                table.name,
                react_1.default.createElement("ul", { className: CustomSqlStyles_1.customSqlQuerySublistClass },
                    react_1.default.createElement(RenderCustomSqlQueryText, { queryText: table.query }))),
            props.customSQLTables.length > 1 ?
                react_1.default.createElement(CopyToClipboard, { queryText: props.customSQLTables[index].query, queryName: props.customSQLTables[index].name })
                : null,
            index < props.customSQLTables.length - 1 ? react_1.default.createElement("div", { className: CustomSqlStyles_1.customSqlDividerClass }) : null);
    })));
}
exports.CustomSqlDialog = CustomSqlDialog;
function CopyToClipboard(props) {
    var onClick = useClipboard(props.queryText, props.queryName);
    return (react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, testId: 'CustomSql-Dialog-Copy', onClick: onClick, style: CustomSqlStyles_1.customSqlCopyButtonStyle }, Localize_1.Messages.DialogCopy()));
}
function RenderDialogFooter(props) {
    var onClick = useClipboard(props.customSQLTables[0].query, props.customSQLTables[0].name);
    return (react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, testId: 'CustomSql-Dialog-Footer-Copy', onClick: onClick, className: CustomSqlStyles_1.customSqlSingleCopyButtonClass }, Localize_1.Messages.DialogCopy()));
}
function RenderCustomSqlQueryText(props) {
    return (react_1.default.createElement("pre", { className: CustomSqlStyles_1.customSqlQueryTextClass },
        react_1.default.createElement("code", { className: CustomSqlStyles_1.codeTextClass }, props.queryText)));
}
function CustomSqlTextLink(props) {
    var _a = react_1.default.useState(false), setIsDialogShowing = _a[0], showDialog = _a[1];
    var queryInfoButton = react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, onClick: function () { return showDialog(true); }, testId: 'Custom-Sql-Text' }, Localize_1.Messages.CustomSqlButtonTitle());
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(widgets_1.InlineAlertWidget, { button: queryInfoButton, testId: 'Custom-SQL-Text-Alert', type: props.containsUnsupportedCustomSql ? widgets_1.InlineAlertType.Warning : widgets_1.InlineAlertType.Info, className: props.contentType === 'Workbook' || props.contentType === 'Flow' ? CustomSqlStyles_1.customSqlWorkbookInlineClass : CustomSqlStyles_1.customSqlGeneralInlineClass }, props.containsUnsupportedCustomSql ? warningInlineText(props.contentType) : infoInlineText(props.contentType)),
        setIsDialogShowing &&
            react_1.default.createElement(CustomSqlDialog, { customSQLTables: props.customSQLTables, onClose: function () { return showDialog(false); }, selectedDropdownName: props.selectedDropdownName })));
}
exports.CustomSqlTextLink = CustomSqlTextLink;
function infoInlineText(contentType) {
    switch (contentType) {
        case 'Workbook':
            return Localize_1.Messages.CustomSqlInfoInlineEmbeddedDatasource();
        case 'Flow':
            return Localize_1.Messages.CustomSqlInfoInlineFlow();
        case 'PublishedDatasource':
            return Localize_1.Messages.CustomSqlInfoInlinePublishedDatasource();
        case 'VirtualConnection':
            return Localize_1.Messages.CustomSqlInfoInlineVirtualConnection();
        default:
            (0, data_catalog_shared_1.assertUnreachable)(contentType);
            return '';
    }
}
function warningInlineText(contentType) {
    switch (contentType) {
        case 'Workbook':
            return Localize_1.Messages.CustomSqlWarningInlineEmbeddedDatasource();
        case 'Flow':
            return Localize_1.Messages.CustomSqlWarningInlineFlow();
        case 'PublishedDatasource':
            return Localize_1.Messages.CustomSqlWarningInlinePublishedDatasource();
        case 'VirtualConnection':
            return Localize_1.Messages.CustomSqlInfoInlineVirtualConnection();
        default:
            (0, data_catalog_shared_1.assertUnreachable)(contentType);
            return '';
    }
}
function useClipboard(queryText, queryName) {
    var _this = this;
    var popToast = react_1.default.useContext(data_catalog_shared_1.UIActionsContext).popToast;
    return react_1.default.useCallback(function (_) { return __awaiter(_this, void 0, void 0, function () {
        var _1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, clipboard.writeText(queryText !== null && queryText !== void 0 ? queryText : '')];
                case 1:
                    _a.sent();
                    popToast('success', !queryName ? '' : Localize_1.Messages.CustomSqlSuccessToast({ queryName: queryName }));
                    return [3 /*break*/, 3];
                case 2:
                    _1 = _a.sent();
                    popToast('error', Localize_1.Messages.CustomSqlFailureToast());
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [queryText, queryName, popToast]);
}
//# sourceMappingURL=CustomSqlDialog.js.map